import { api } from './api';

export type MilestoneKey =
  | 'connect_source' | 'ingest_facts' | 'first_forecast'
  | 'first_pivot' | 'first_kpi' | 'board_pack' | 'invite_team';

export interface ActivationMilestone {
  key: MilestoneKey;
  done: boolean;
}

export interface ActivationSummary {
  milestones: ActivationMilestone[];
  doneCount: number;
  total: number;
  trial: {
    onTrial: boolean;
    trialEndsAt: string | null;
    daysLeft: number;
    effectivePlan: 'free' | 'growth' | 'enterprise';
  };
}

export const activationApi = {
  summary: async (wsId: string): Promise<ActivationSummary> =>
    (await api.get(`/api/billing/workspaces/${wsId}/activation`)).data,
};
